class LqdImageTextSliderHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.initActiveOnHover();
    this.initVideoBg();

  }

  getDefaultSettings() {
    return {
      selectors: {
        activeOnHoverElement: '[data-active-onhover]',
        videoBgElement: '[data-video-bg]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $activeOnHoverElement: this.$element.find(selectors.activeOnHoverElement),
      $videoBgElement: this.$element.find(selectors.videoBgElement),
    }
  }

  initActiveOnHover() {

    this.elements.$activeOnHoverElement.liquidSetActiveOnhover();

  }

  initVideoBg() {

    this.elements.$videoBgElement.liquidVideoBg();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleActiveOnHoverDestroy();

  }

  handleActiveOnHoverDestroy() {

    if ( ! this.elements.$activeOnHoverElement.length ) return;

    const activeOnHoverData = this.elements.$activeOnHoverElement.data('plugin_liquidSetActiveOnhover');

    if ( activeOnHoverData ) {
      activeOnHoverData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdImageTextSliderHandler, { $element } );
};